import React from 'react';
import Sheet from 'react-modal-sheet';
import Terms from './Terms';

const TermsModal = ({ isOpen, onClose, sendSpinner, customDetails }) => {
	return (
		<Sheet isOpen={isOpen} onClose={onClose}>
			<Sheet.Container>
				<Sheet.Header>
					<div style={{ textAlign: 'right' }}>
						<button
							className="closeModal"
							onClick={onClose}
							style={{
								background: 'none',
								border: 'none',
								fontSize: '18px',
								fontWeight: 'bold',
								cursor: 'pointer',
								padding: '10px',
							}}
						>
							X
						</button>
					</div>
				</Sheet.Header>
				<Sheet.Content>
					<Terms />
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop />
		</Sheet>
	);
};

export default TermsModal;
